'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES, ROUTES, WEL_MARKET_ROUTES } from '@/constants';
type ServiceKey = 'wello' | 'donation' | 'market';
interface ServiceItem {
  key: ServiceKey;
  label: string;
  href: string;
  iconSrc: string;
}
const SERVICE_ITEMS: Record<ServiceKey, ServiceItem> = {
  wello: {
    key: 'wello',
    label: '웰로',
    href: ROUTES.HOME.pathname,
    iconSrc: '/assets/svgs/brand/wello-badge.png'
  },
  donation: {
    key: 'donation',
    label: '고향사랑기부',
    href: DONATION_ROUTES.HOME.pathname,
    iconSrc: '/assets/svgs/brand/donation-badge.png'
  },
  market: {
    key: 'market',
    label: '웰마켙',
    href: WEL_MARKET_ROUTES.HOME.pathname,
    iconSrc: '/assets/svgs/brand/market-badge.png'
  }
};
interface ServiceSwitchDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  currentService: ServiceKey;
  className?: string;
}
export const ServiceSwitchDropdown = t0 => {
  const $ = _c(10);
  const {
    isOpen,
    onClose,
    currentService,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.keys(SERVICE_ITEMS);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentService) {
    t2 = (t1 as ServiceKey[]).filter(key => key !== currentService).map(_temp);
    $[1] = currentService;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const items = t2;
  let t3;
  if ($[3] !== className || $[4] !== isOpen || $[5] !== items || $[6] !== onClose) {
    t3 = isOpen ? <><motion.div aria-hidden={true} className="fixed inset-0 z-40 bg-Gray-black/50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} onClick={onClose} /><motion.div className={cn("shadow-large absolute bottom-full left-0 z-50 mb-12 min-w-160 rounded-large bg-Gray-white px-16 py-12", className)} initial={{
        opacity: 0,
        y: 8,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.95
      }} transition={{
        type: "spring",
        stiffness: 500,
        damping: 35
      }} role="menu" aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"}><ul className="flex flex-col gap-4">{items.map(t4 => {
            const {
              key: key_1,
              label,
              href,
              iconSrc
            } = t4;
            return <li key={key_1}><CustomLink href={href} onClick={onClose} className="flex items-center gap-8 rounded-medium py-8 duration-150" role="menuitem"><Image alt="" aria-hidden={true} className="size-32 shrink-0 rounded-medium" src={iconSrc} width={32} height={32} /><span className="font-500 text-Gray-900 typo-body4">{label}</span></CustomLink></li>;
          })}</ul></motion.div></> : null;
    $[3] = className;
    $[4] = isOpen;
    $[5] = items;
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(key_0) {
  return SERVICE_ITEMS[key_0];
}